import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from '../../../config/config.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { handleProblem } from '../../problems/problem.service';

@Injectable()
export class UpdatePartnerService {

  public constructor(private client: HttpClient, private configService: ConfigService) {}

  public partnerUpdate(id: string, updatePatch: Array<any>): Observable<void> {
    const url = `${this.configService.config.rest.apiV2Url}/partners/${id}`;

    return this.client.patch<void>(url, updatePatch,{
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json'
      })
    }).pipe(
      catchError(error => throwError(handleProblem(error)))
    );
  }
}
